<template>
  <div>

    <div class="media" >

      <div class="media-left media-middle">
        <a href="javascript://" tabindex="0" class="" style="color:black; display: inline;" role="button" data-toggle="popover" data-trigger="hover" data-placement="left" 
          :title="tooltipTitle()" 
          :data-content="tooltipContent()"
          @click="editModus = true"
        >
        <i class="fa fa-lg" aria-hidden="true"
         :class="[completionSymbol(history.completion)]" 
        ></i>
        </a>
      </div>

      <div class="media-body">
        <div>
          <strong>{{getDateTime(history.datetimeBegin)}}</strong>
          - {{history.userCallerName}} <span v-if="modeActiveCall">({{history.companyCallerName}})</span>, für {{history.userClientName}}  <span v-if="!modeActiveCall">, {{history.companyClientName}}({{history.calledNumber}})</span>
        </div>
        <div style="max-width: 45em" class="cc-msg">
          <small v-show="!history.message"><i>- kein Nachricht hinterlegt -</i></small>
          <small>{{history.message}}</small>
        </div>
      </div>

      <div class="media-right text-right media-middle">
        <button type="button"
                title="Eintrag bearbeiten"
                class="btn  btn-link cc-btn-menue"
                @click="editModus = true">
                <span class="glyphicon glyphicon-option-vertical"></span>
        </button>
      </div>

    </div>
            
    
  
    <cc-message-modal v-if="editModus">

      <div slot="header">
        <h3 v-html="tooltipTitle()"></h3>
      </div>
      
      <div slot="body">
       <div v-html="tooltipContent()"></div>
       
       <h3>Kommentar zum Call:</h3>
       <textarea 
        class="form-control"
        rows="3" 
        placeholder="Kommenta zum Call eingeben..."  
        v-model="comment"   
       >
          </textarea>

      </div>
      
      <div slot="footer">
        <button v-if="comment" type="" class="btn btn-primary"  @click="onClickSave">Speichern</button>
        <button type="" class="btn btn-default"  @click="editModus = false">Schließen</button>
      </div>

    </cc-message-modal>

  </div>
  
</template>



<script>

import bus from './common/bus'
import moment from 'moment'  
import * as KomboxConf from './common/kombox.conf'
import MessageModal from './MessageModal.vue'


export default {
    
  components: {
          'cc-message-modal': MessageModal,
  },
  
  data () {
    return {
      KomboxConf: KomboxConf,
      editModus: false,
      message: '',
      comment: '',
      modeActiveCall: false
    }
  },
  
  props: {
      history: {},
  },
  
  created: function () {
  },

  mounted: function () {
    if(bus.call.idCompanyClient == 0){
      this.modeActiveCall = false
    }else{
      this.modeActiveCall = true
    }
  },
 

  
  computed: {
    
    
  },
  
  methods: {
    
    onClickEdit: function () {
      this.editModus = 'edit';
    },
    
    onClickSave: function () {
      this.saveComment()
    },
    
    saveComment: function () {
      this.$http.post(bus.config.path + '/call/addcomment/' + this.history.idCall, {comment: this.getComment()} ).then((response)  => {
        
        console.log('HistoryItem:saveComment:' + JSON.stringify(response.data, null, 2));
        this.history.message = response.data;
        this.comment = ''
        
      }, (response) => {
      // error callback
      });
    },
    
    
    getComment: function () {
      if(this.comment){
        let d = new Date();
        return '\n\n--- Kommentar von ' + bus.call.idUserCallCenter + ' am ' + moment(d).format('DD.MM.YYYY, HH:mm') + '\n' + this.comment + '\n---';
      }
      return '';
    },
  

    completionSymbol: function (completion) {
      
      if (completion.match("^Abschluss")) {
          return 'fa-send'
      }
      
      if (completion.match("^Papierkorb")) {
        return 'fa-trash'
      }
      
      if (completion.match("^Abbruch")) {
        return 'fa-times-circle'
      }
      
      if (completion.match("^Parking")) {
        return 'fa-thumb-tack'
      }
    
    },
    
    tooltipTitle: function () {
      let historyCall = this.history
      
      let ret = '';
      
      ret += historyCall.completion + ': '
      ret += this.getDateTime(historyCall.datetimeBegin) + ' - '
      ret += 'Agent: ' + historyCall.userCallCenterName
      ret +='<a style="position: absolute; right: 0; top: 0; text-align: right" class="btn btn-link" onclick="' + "$(this).parent().parent().popover('hide')" + '"><i class="fa fa-times" aria-hidden="true"></i></a>'
      return ret
    },

    tooltipContent: function () {
      let historyCall = this.history
      
      let ret = '';
      
      ret += '<i>' + historyCall.userCallerName
      
      if(historyCall.companyCallerName){
        ret += ' (Fa. ' + historyCall.companyCallerName + ')'
      }
      
      ret += ' für ' + historyCall.userClientName + ', ' + historyCall.companyClientName + '(' + historyCall.calledNumber + ')' + '</i>'
      
      ret += '<h3>Nachricht:</h3>'
      ret += historyCall.message.replace(/\n/g,"<br>") || '<i>keine Nachricht hinterlassen!</i>'
      
      ret += '<h3>Kontakt:</h3>'
      let kontakt = ''
      historyCall.KomboxesUserCaller.map(
        item => kontakt += this.KomboxConf.TYPES[item.type].OPTION.TEXT + ': ' + item.content + ' - ' + item.description + '<br>'
      ) 
      ret += kontakt || '<i><b>Keine Kontaktdaten hinterlegt!</b></i>'
        
      ret += '<h3>Versand an:</h3>'
      let versand = ''
      historyCall.callShipments.map(
        item => versand += this.KomboxConf.TYPES[item.kombox.type].OPTION.TEXT + ': ' + item.kombox.content + ' - ' + item.kombox.description + '<br>'
      )
      ret += versand || '<i><b>Keine Veranad aktiviert!</b></i>'
      
      
      return ret
    },


    getDateTime: function (dateTime) {
      moment.locale('de');
      let d = new Date(dateTime);
      let d_now = new Date();
      let dateString = '';
      
      
      if(d.toDateString() == d_now.toDateString()){
        dateString = 'Heute, ' + moment(d).format('HH:mm');
      }else{
        dateString = moment(d).format('dd DD.MM, HH:mm');
      }
      return dateString;
    },

    reset: function () {
    },
    


    
  }
  
}
</script>

<style>

  .popover{
     width: 30%;
     max-width: 100% !important;
     box-shadow: 0px 0px 20px #333;  
     /*background-color: #fcf8e3;*/
  }

  .popover-title{
    font-weight: bold;
  }

</style>


  <style scoped>

  
  .cc-panel-default:hover{
     background-color: #fcf8e3;
  }
  
  .cc-msg{
    overflow: hidden;
    white-space: nowrap;
    margin-right: 10px
  }  
  
h2 .fa, .panel .fa {
    padding-right: 2px;
}
  
    .fa-send{
      color: #449d44;      
    }
    
    .fa-trash{
      color: #f0ad4e;       
    }
    .fa-times-circle{
      color: #d9534f;
    }
    
    .fa-thumb-tack{
      color: #337ab7;       
    }
  
  small{
    color: gray;
  }  
  
.panel {
    margin-bottom: 4px;
    border-bottom: 1px solid lightgrey;
}

.panel-title{
  font-size: 14px  ;
}


</style>



// WEBPACK FOOTER //
// HistoryItem.vue?68bc0b7b